import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useT } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";

const BillingSuccess = () => {
  const { t } = useT();
  const { refresh } = useAuth();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let done = false;
    const run = async () => {
      if (!sessionId) {
        setChecking(false);
        return;
      }
      try {
        await api(`/billing/status/${sessionId}`);
        await refresh();
      } catch (e) {
        console.warn("Betaalstatus ophalen mislukt:", e);
      }
      if (!done) setChecking(false);
    };
    run();
    return () => {
      done = true;
    };
  }, [sessionId, refresh]);

  return (
    <div className="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center px-4 text-center">
      {checking ? (
        <Loader2 className="animate-spin text-brandblue" size={40} />
      ) : (
        <>
          <CheckCircle2 className="text-success" size={56} />
          <h1 className="mt-6 font-display text-2xl font-extrabold text-navy">{t("billing.success.title")}</h1>
          <p className="mt-3 text-slate-500">{t("billing.success.desc")}</p>
          <Button asChild className="mt-8 rounded-xl bg-brandblue hover:bg-brandblue/90">
            <Link to="/dashboard" data-testid="billing-success-cta">{t("billing.success.cta")}</Link>
          </Button>
        </>
      )}
    </div>
  );
};

export default BillingSuccess;
